var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'gt-tabs': true,
    'gt-tabs--has-margin': _vm.needTopMargin
  }},[_c('el-tabs',{attrs:{"type":_vm.type},on:{"tab-click":_vm.handleClickTab},model:{value:(_vm.newActName),callback:function ($$v) {_vm.newActName=$$v},expression:"newActName"}},_vm._l((_vm.statusCountListCom),function(ref,index){
  var label = ref.label;
  var value = ref.value;
  var qty = ref.qty;
return _c('el-tab-pane',{key:index,attrs:{"label":(label + " " + (qty != undefined ? '(' + qty + ')' : '')),"name":value + '' || '#'}})}),1),(_vm.hasButton)?_c('div',{staticClass:"gt-tabs__btns"},[_vm._t("buttons")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }